import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/billing.json';
import ar from './i18n/ar/billing.json';

registerFeatureI18n('billing', { en, ar });

export { BillingPage } from './BillingPage';
